import { appConfig } from 'config/app'

import { createStore } from './createStore'
import { dataGridReducers } from './dataGridReducers'

const { store, persistor } = createStore(
  {
    ...dataGridReducers,
  },
  {
    key: 'root',
    devTools: appConfig.appEnv === 'development',
    version: 1,
    blacklist: [],
  },
)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export { store, persistor }
